// Creates a Date/Time input
// use .val() to set and retrieve date time

import _ from 'lodash';
import $ from 'jquery';
import dateTimeTemplate from '../templates/dateTime.hbs';
import timeListItemTemplate from '../templates/timeListItem.hbs';
import moment from 'moment';
import 'jquery-ui';
import './sdaSelect';
import './sdaSelectList';
import './sdaListSelector';

const increments = 1000 * 60 * 30; // every 30 minutes

//:: Milliseconds -> Milliseconds
const roundTimeToIncrements = time => time - (time % increments);

// Get time of day in milliseconds
//:: moment -> Milliseconds
const getTimeOfDay = dateTime =>
    dateTime.hour() * 60 * 60 * 1000 + dateTime.minute() * 60 * 1000 + dateTime.seconds() * 1000;

//:: moment -> Milliseconds
const getRoundedTime = _.flow(
    getTimeOfDay,
    roundTimeToIncrements,
);

//:: moment -> Boolean
const dateIsValid = date => date.isValid() && date.isBetween(moment.utc('2000-01-01'), moment.utc().add(5, 'years'));

const updateDateTime = ($el, $calendar, $select) => {
    const dateStr = $calendar.val();
    const date = moment.utc(dateStr, ['MM/DD/YYYY', 'YYYY-MM-DD']).startOf('day');
    let dateTime;

    // Check for valid date in input
    if (dateIsValid(date)) {
        $calendar.sdaRemoveError();
        $select.enable();
        const time = parseInt($select.val(), 10);
        dateTime = date.add(time, 'ms').valueOf();
        $el.data({val: dateTime});
    } else {
        //field is optional so '' isn't an error
        if (dateStr.length) {
            $calendar.sdaError('Invalid date');
        }
        $select.disable();
        $el.data({val: null});
    }

    $el.trigger('change.val', dateTime);
};

const getTimeData = _.memoize(() => {
    const timeData = [];
    for (let i = 0; i < 86340000; i += increments) {
        const totalMin = Math.floor(i / 1000 / 60);
        const min = ('0' + (totalMin % 60)).slice(-2);
        let hour = Math.floor(totalMin / 60);
        const amPm = hour > 11 ? 'pm' : 'am';

        if (hour === 0) {
            hour = 12;
        } else if (hour > 12) {
            hour -= 12;
        }

        timeData.push({
            time: hour + ':' + min + ' ' + amPm,
            val: i,
        });
    }
    timeData[0].time = 'midnight';
    timeData[24].time = 'noon'; //HACK will break if increments change
    return timeData;
});

const sdaDateTime = (el, data) => {
    const $el = $(el);
    el.type = 'sdaDateTime';
    data = Object.assign({}, data, $el.data());
    $el.html(dateTimeTemplate(data));
    const $calendar = $el.find('.sda-calendar-input');
    const $select = $el.find('.sda-select');
    const isDisabled = $el.attr('disabled') === 'disabled';
    $el.on('disabledChange', function() {
        $calendar.datepicker('option', 'disabled', el.hasAttribute('disabled'));
    });
    $select
        .sdaSelect({template: timeListItemTemplate, list: getTimeData()})
        .disable()
        .on('change.val', e => {
            e.stopPropagation();
            updateDateTime($el, $calendar, $select);
        });

    $calendar
        .datepicker({
            beforeShow() {
                $('#ui-datepicker-div').addClass('sda-calendar sda-calendar--dateTime');
            },
            onSelect() {
                $calendar.trigger('change.val');
            },
            disabled: isDisabled,
        })
        .on('change.val', e => {
            e.stopPropagation();
            updateDateTime($el, $calendar, $select);
        })
        .on('change', () => updateDateTime($el, $calendar, $select));

    if ($el.attr('value')) {
        $el.val($el.attr('value'));
    }

    $el.attachMethod('reset', function() {
        $calendar.val('');
        $select.val(getTimeData()[0].val);
    });
};

$.fn.sdaDateTime = function(data) {
    return this.each((__, el) => sdaDateTime(el, data));
};

$.valHooks.sdaDateTime = {
    get(el) {
        const result = parseInt($(el).data().val, 10);
        if (el.hasAttribute('disabled') || isNaN(result)) {
            return null;
        }
        return result;
    },
    set(el, val) {
        const $el = $(el);
        if (val === '') {
            return;
        }
        val = parseInt(val, 10);

        if (isNaN(val)) {
            console.error('Value parses to NaN');
        }

        const dateTime = moment.utc(val);
        $el.find('.sda-calendar-input').val(dateTime.format('MM/DD/YYYY'));
        $el.find('.sda-select')
            .val(getRoundedTime(dateTime))
            .enable();

        $el.data({val});
        $el.trigger('change.val', val);
    },
};
